export const videnc = {
  videnc: {
    defaultEdidResolution: '1920x1080p60 (Default)',
    dynamicPartialImageSkip: 'Enabled Dynamically',
    fields: {
      aspectRatio: 'Aspect Ratio',
      bitrate: 'Bitrate',
      chromaSubSampling: 'Chroma Subsampling',
      closedCaption: 'Closed Captioning',
      codecAlgorithm: 'Codec Algorithm',
      colorSpace: 'Color Space',
      colorSpaceActual: 'Detected Color Space',
      copyProtectedContent: 'Copy Protected Content',
      countingMode: 'Counting Mode',
      cropping: 'Resizing',
      dailyResync: 'Daily Resync',
      dynamicRangeMode: 'Dynamic Range',
      encodingProfile: 'Encoding Profile',
      firFilter: 'FIR Filter',
      gopStructure: 'Framing',
      gopSize: 'GOP Size',
      hdcp: 'HDCP',
      inputFormat: 'Input Format',
      inputInterface: 'Input Interface',
      intraRefresh: 'Intra Refresh',
      maxBitrate: 'Max Bitrate',
      name: 'Name',
      partialFrameSkip: 'Partial Image Skip',
      pictureRate: 'Frame Rate',
      preferredResolution: 'Preferred Resolution',
      rateControl: 'Rate Control',
      resizing: 'Resizing', // TODO CANDIDATE for DELETION
      resolution: 'Resolution',
      resyncHour: 'Resync Hour',
      squareDivisionCapture: 'Square Division',
      sceneChangeDetection: 'Scene Change Detection',
      slices: 'Slices',
      timeCode: 'Timecode Source',
      dataInput: 'ANC Data Input',
    },
    sections: {
      input: 'INPUT',
      encoderParameters: 'SETTINGS',
    },
    statistics: {
      sections: {
        main: 'Statistics',
      },
      aspectRatio: 'Input Aspect Ratio',
      closedCaptioning: 'Closed Captioning',
      droppedFrames: 'Dropped Frames',
      encodedBitRate: 'Encoded Bitrate',
      encodedBytes: 'Encoded Bytes',
      encodedFrames: 'Encoded Frames',
      encodedFrameRate: 'Encoded Frame Rate',
      encoderLoad: 'Encoder Load',
      encoderPTS: 'Encoder PTS',
      encoderResets: 'Encoder Resets',
      CCErrors: 'CC Errors',
      extractedAFDBytes: 'Extracted AFD Bytes',
      extractedCSDBytes: 'Extracted CSD Bytes',
      extractedCCBytes: 'Extracted CC Bytes',
      h264Level: 'H.264 Level',
      h264Profile: 'H.264 Profile',
      h265Level: 'H.265 Level',
      h265Profile: 'H.265 Profile',
      h265Tier: 'H.265 Tier',
      name: 'Name',
      inputColorPrimaries: 'Input Color Primaries',
      inputMatrixCoefficients: 'Input Matrix Coefficients',
      inputTransferCharacteristics: 'Input Transfer Characteristics',
      signaledDynamicRange: 'Signaled Dynamic Range',
      scalerLoad: 'Scaler Load',
      inputPresent: 'Input Present',
      inputFormat: 'Input Format',
      inputType: 'Input Type',
      numberOfSlices: 'Number Of Slices',
      hdcp: 'HDCP',
      hdcpAuthenticated: 'HDCP Authenticated',
      hdcpEncrypted: 'HDCP Encrypted',
      resolution: 'Output Resolution',
      timecode: 'Timecode',
      sceneChangesDetected: 'Scene Changes Detected',
      lastSceneChange: 'Last Scene Change',
      sourceSwitches: 'Source Switches',
      timecodeSource: 'Timecode Source',
      upTime: 'Uptime',
      UTC: 'UTC',
    },
    link: {
      statistics: 'Statistics',
      expandThumbnail: 'Show Preview',
      disabledThumbnail: '(preview disabled)',
      hideThumbnail: 'Hide Preview',
    },
    notifications: {
      settingsChangeSuccessMsg: 'Video encoder updated',
      settingsChangeErrorMsg: 'Video encoder could not be updated',
      startError: 'Video encoder could not be started',
      startError_plural: '{{count}} video encoders could not be started',
      stopError: 'Video encoder could not be stopped',
      stopError_plural: '{{count}} video encoders could not be stopped',
    },
    resolution: 'Resolution',
    states: {
      STOPPED: 'STOPPED',
      AWAIT_FRAMING: 'AWAIT FRAMING',
      NOT_ENCODING: 'NOT ENCODING',
      WORKING: 'ENCODING',
      RESETTING: 'RESETTING',
      FAILED: 'FAILED',
    },
    enums: {
      aspectRatio: {
        0: 'Automatic',
        13: '3:2',
        2: '4:3',
        3: '5:3',
        4: '5:4',
        5: '16:9',
        14: '16:10',
        15: '17:9',
        20: '1:2',
        1: 'WSS/AFD',
      },
      chromaSubSampling: {
        1: '4:2:0 8-bit',
        2: '4:2:0 10-bit',
        3: '4:2:2 8-bit',
        4: '4:2:2 10-bit',
      },
      codecAlgorithm: {
        0: 'AVC/H.264',
        1: 'HEVC/H.265',
      },
      codecAlgorithmShort: {
        0: 'H.264',
        1: 'H.265',
      },
      colorSpace: {
        undefined: '',
        Auto: 'Auto-Detect',
        RGB_8bit_limited: 'RGB 8bit limited',
        RGB_8Bit_full: 'RGB 8bit full',
        RGB_10bit_limited: 'RGB 10bit limited',
        RGB_10Bit_full: 'RGB 10bit full',
        RGB_12bit_limited: 'RGB 12bit limited',
        RGB_12Bit_full: 'RGB 12bit full',
        RGB_16bit_limited: 'RGB 16bit limited',
        RGB_16Bit_full: 'RGB 16bit full',
        YCbCr_422_8bit_limited: 'YCbCr 422 8 bit limited',
        YCbCr_422_8Bit_full: 'YCbCr 422 8bit full',
        YCbCr_422_10bit_limited: 'YCbCr 422 10bit limited',
        YCbCr_422_10bit_full: 'YCbCr 422 10bit full',
        YCbCr_422_12bit_limited: 'YCbCr 422 12bit limited',
        YCbCr_422_12bit_full: 'YCbCr 422 12bit full',
        YCbCr_422_16bit_limited: 'YCbCr 422 16bit limited',
        YCbCr_422_16bit_full: 'YCbCr 422 16bit full',
        YCbCr_444_8bit_limited: 'YCbCr 444 8bit limited',
        YCbCr_444_8bit_full: 'YCbCr 444 8bit full',
        YCbCr_444_10bit_limited: 'YCbCr 444 10bit limited',
        YCbCr_444_10bit_full: 'YCbCr 444 10bit full',
        YCbCr_444_12bit_limited: 'YCbCr 444 12bit limited',
        YCbCr_444_12bit_full: 'YCbCr 444 12bit full',
        YCbCr_444_16bit_limited: 'YCbCr 444 16bit limited',
        YCbCr_444_16bit_full: 'YCbCr 444 16bit full',
      },
      countingMode: {
        1: 'SMPTE 12M-1',
        0: 'UTC Conversion',
      },
      cropping: {
        0: 'Scale',
        1: 'Crop',
      },
      dynamicRangeMode: {
        0: 'Off (SDR/BT.709)',
        1: 'Automatic',
        2: 'HDR-HLG',
        3: 'HDR-PQ',
      },
      encapsulation: {
        2: 'UDP',
        3: 'RTP',
        34: 'SRT',
        64: 'RTSP',
      },
      encodingProfile: {
        1: 'Baseline',
        2: 'Main',
        3: 'High',
        4: 'High 10',
        5: 'High 4:2:2',
        6: 'Main 10',
        7: 'Main 4:2:2 10',
      },
      gopStructure: {
        1: 'I',
        0: 'IP',
        2: 'IBP',
        3: 'IBBP',
        4: 'IBBBP',
        5: 'IBBBBP',
      },
      inputInterface: {
        '-1': 'Automatic',
        0: 'Unknown',
        1: 'SDI',
        2: 'Composite',
        3: 'HDMI',
      },
      rateControl: {
        0: 'CBR',
        1: 'CVBR',
        2: 'LowLatency VBR',
      },
      resyncHour: {
        0: '00:00 (Midnight)',
        1: '01:00 (1 AM)',
        2: '02:00 (2 AM)',
        3: '03:00 (3 AM) ',
        4: '04:00 (4 AM)',
        5: '05:00 (5 AM)',
        6: '06:00 (6 AM)',
        7: '07:00 (7 AM)',
        8: '08:00 (8 AM)',
        9: '09:00 (9 AM)',
        10: '10:00 (10 AM)',
        11: '11:00 (11 AM)',
        12: '12:00 (Noon)',
        13: '13:00 (1 PM)',
        14: '14:00 (2 PM)',
        15: '15:00 (3 PM)',
        16: '16:00 (4 PM)',
        17: '17:00 (5 PM)',
        18: '18:00 (6 PM)',
        19: '19:00 (7 PM)',
        20: '20:00 (8 PM)',
        21: '21:00 (9 PM)',
        22: '22:00 (10 PM)',
        23: '23:00 (11 PM)',
      },
      stillImageEnum: {
        0: '',
        1: 'Freeze',
        2: 'Black',
        3: 'Blue',
        4: 'Color bars',
        5: 'Mute',
        6: 'Custom',
      },
      timeCode: {
        0: 'None',
        1: 'Video',
        2: 'System',
      },
    },
    noInput: 'No Input',
    sceneChangeThreshold: 'Scene Change Percentage',
    stillImage: 'Still Image',
    stillImageDelay: 'Still Image Delay',
    video: 'Video',
    videoFrameRate: 'Frame Rate',
    videoStopped: 'VIDEO ENCODER STOPPED',
    videoNoInput: 'NO VIDEO INPUT',
  },
};
